import { Event_ } from '../Event_';
export class ClipboardEvent_ extends Event_ {
    get clipboardData() {
        return this.reactEvent.clipboardData;
    }
}
